var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0049 4.50308L2.12324 20.9998C1.9195 21.3526 1.8117 21.7526 1.81056 22.16C1.80942 22.5674 1.91497 22.9681 2.11673 23.322C2.31849 23.676 2.60942 23.971 2.96056 24.1776C3.31171 24.3842 3.71083 24.4953 4.11824 24.4998H23.8816C24.289 24.4953 24.6881 24.3842 25.0392 24.1776C25.3904 23.971 25.6813 23.676 25.8831 23.322C26.0848 22.9681 26.1904 22.5674 26.1893 22.16C26.1881 21.7526 26.0803 21.3526 25.8766 20.9998L15.9949 4.50308C15.7869 4.16021 15.4941 3.87672 15.1446 3.67998C14.7952 3.48324 14.4009 3.37988 13.9999 3.37988C13.5989 3.37988 13.2046 3.48324 12.8552 3.67998C12.5057 3.87672 12.2129 4.16021 12.0049 4.50308Z",
    stroke: "#2F1C0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5V15.1667",
    stroke: "#2F1C0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.833H14.0113",
    stroke: "#2F1C0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.8a90f871a14a22cc6200eeb576f20117.svg";
export { ForwardRef as ReactComponent };